import React from 'react';
import Box from '@mui/material/Box';
import { Sponsors, SponsorsProps } from 'src/components/leaderboards/Sponsors';
import { DialogCentered } from 'src/components/DialogCentered';
import { useMobile } from 'src/hooks/useMobile';
import { GradientIconButton } from 'src/components/gradients/GradientIconButton';
import { SxProps } from '@mui/material/styles';
import { GradientBorder } from 'src/components/gradients/GradientBorder';
import CloseIcon from '@mui/icons-material/Close';

export type BracketPanelProps = {
  MatchDetails?: React.ReactNode;
  onClose: () => void;
  sx?: SxProps;
} & SponsorsProps;

export function BracketPanel(props: BracketPanelProps) {
  const { MatchDetails, onClose, sx } = props;
  const isMobile = useMobile();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {!!MatchDetails && (
        <>
          {isMobile ? (
            <DialogCentered
              open={!!MatchDetails}
              onClose={onClose}
              innerSx={{ p: 0, pt: -2 }}
              sx={{
                '.MuiPaper-root': { overflow: 'visible' },
                height: '197px',
              }}
              contentSx={{ overflow: 'visible' }}
            >
              {MatchDetails}
            </DialogCentered>
          ) : (
            <Box sx={{ ...sx }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                {!isMobile && (
                  <GradientIconButton
                    IconComponent={CloseIcon}
                    onClick={onClose}
                    sx={{ height: '20px', width: '20px', zIndex: 10 }}
                  />
                )}
              </Box>
              <GradientBorder borderRadius="10px" disableBorder={isMobile}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '220px',
                  }}
                >
                  {MatchDetails}
                </Box>
              </GradientBorder>
            </Box>
          )}
        </>
      )}
      {(!MatchDetails || isMobile) && <Sponsors {...props} />}
    </Box>
  );
}
